export enum UseCaseWithMessage {
  'alir1035ExchangeRemoved',
  'cashValueReplacementRemoved',
  'alir1035ExchangeAmount',
  'retirementReasonForInsurance',
}

export const UseCaseWithMessageText = {
  alir1035ExchangeRemoved:
    'By removing a 1035 exchange from the Policy Information section, you are also setting the cash value transfer to zero in the Existing Coverage section. Once you close this window we will remove the 1035 exchange from Policy Information section and set the cash value transfer to zero in Existing Coverage section. Contact your financial professional if you have questions.',
  cashValueReplacementRemoved:
    'By removing a 1035 exchange from the existing coverage section, you are also removing a 1035 exchange from the Policy Information section. Once you close this window we will clear the 1035 exchange from both sections. Contact your financial professional if you have questions.',
  alir1035ExchangeAmount:
    'By adding a 1035 exchange from the Policy Information section, you are also adding a 1035 exchange to the Existing Coverage section. You will need to fill in the 1035 exchange information in the Existing Coverage section before you can continue. Contact your financial professional if you have questions.',
  retirementReasonForInsurance:
    'If the insured has applied for the Chronic Illness Rider, the Insured understands that this Rider is not considered Qualified Long Term Care insurance under the Internal Revenue Code.',
};

export const UseCaseWithMessageHeader = {};
